// removed by extract-text-webpack-plugin
module.exports = {"component":"CRd-734rk-pOr6ZZJe_Og","header":"-_zUa-ixG23KIEmKETsd0","instructions":"luJBEld7nZv5IKx6fChCH","table":"_1t3P_do9Rm4_1SmRUmTMTw","label":"_1OumzXLiiwFZHgguI2OseT","controlCell":"_1acax47BoG1FBHa9Rg9AZE","select":"R8f81OB_MllsDANm_SYgi","textarea":"_3VtzOMp-OpFrKLDBDcKhJk","btnCell":"Gh8qGvmZCQutPgiX5R0FO","btn":"_2WUcl9QkIrlXaJVTC2MQII","backgroundLine":"_1kqwVft0DhGhYxCQck1HcX","text":"_2zqiJkOa95EMyWM9NOUOXk","firstAvailableLabel":"_2tAREqCgol1BcOFMnDxdKR","firstAvailableCheckbox":"_2LucOZknLJvndeVwE-u4uI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Appointments/Waitlist/Waitlist.css
// module id = 1442
// module chunks = 0